import React from "react";
import NotificationsIconRenderer from "./NotificationsIconRenderer";
import CloseButton from "../../../components/Common/CloseButton";
import moment from "moment-timezone";

const NotificationCard = ({
  isFetching,
  delete: deleteFunction,
  notification: { id, title, message, status, timestamp, read },
  handleNotificationClick,
  canDelete = true,
}) => {
  const handleCardClick = () => {
    if (!isFetching) {
      handleNotificationClick(id, !read || read === "no");
    }
  };
  const handleDelete = (e) => {
    if (!isFetching) {
      e.stopPropagation();
      deleteFunction(id, !read);
    }
  };

  return (
    <div
      className={
        "notificationCard " +
        (!read || read === "no" ? "unread" : "") +
        (" " + status?.toLowerCase())
      }
      onClick={handleCardClick}
    >
      <div className="icon">
        <NotificationsIconRenderer name={status?.toLowerCase()} />
      </div>
      <div className="detail w-100">
        <h2 className="notification-card__title d-flex justify-content-between align-items-start mb-1 text-darkN">
          <span style={{ textTransform: "capitalize" }}>{title}</span>
          {!isFetching && canDelete && (
            <CloseButton
              theme="light"
              color="red"
              height={12}
              onClick={handleDelete}
            />
          )}
        </h2>
        <p className="notification-card__message">{message}</p>
        <p className="notification-card__time">
          {timestamp ? moment(timestamp).format("DD-MM-YYYY HH:mm:ss") : ""}
        </p>
      </div>
    </div>
  );
};

export default NotificationCard;
